<template>
  <div id="vista-seleccion-consorcios" v-if="acuerdo_comercial_copy">
    <div class="pa-6">
      <div class="titulo-principal mb-4">Seleccion de administración y consorcios</div>
      <v-form
        ref="formulario_vista_seleccion_consorcios"
      >

        <busqueda-administracion
          :administracion.sync="acuerdo_comercial_copy.administracion"
          :administraciones="administraciones"
          @selecciono-administracion:actualizar="buscarConsorcios($event)"
        />

        <template v-if="acuerdo_comercial_copy.administracion">
          <div class="tabla-container mt-6">

            <div class="d-flex justify-space-between align-center contenedor-fila-filtros">

              <!-- Chip totalizador de consorcios seleccionados -->
              <ca-chip
                disabled
                contentClass="chip-totalizador mr-2"
              >
                <template>
                  <div class="d-flex justify-center align-center">
                    <span>Seleccionados:</span>
                    <span class="chip-totalizador--texto-oscuro">{{ cantidadConsorciosSeleccionados }}</span>
                  </div>
                </template>
              </ca-chip>

              <!-- Switch consorcios no disponibles -->
              <div class="switch-deshabilitadas">
                <v-switch
                  v-model="mostrar_deshabilitadas"
                  label="Ver no disponibles"
                  color="accent"
                >
                </v-switch>
              </div>
            </div>

            <!-- Filtro de búsqueda -->
            <div class="ca-filtro mb-2">
              <ca-filtro
                :items_sin_filtrar="consorcios"
                :keys="['id','nombre']"
                :items.sync="consorcios_filtrados_por_ca_filtro"
                :filtro.sync="filtro_ca_tabla"
                placeholder="Filtrar por nombre o código"
              />
            </div>

            <div class="tabla-consorcios">
              <ca-tabla
                :items="consorciosFiltrados"
                filas_hover
                scrollable
                ocultar_header
                no_data_text="No se encontraron consorcios"
              >
                <template slot="item" slot-scope="props">
                  <tr>
                    <td :class="'pr-0 columna-checkbox ' + estiloFilaDeshabilitada(props.item)">
                      <v-checkbox
                        class="tabla-checkbox"
                        color="accent"
                        :disabled="props.item.deshabilitado"
                        v-model="props.item.seleccionado"
                        @change="seleccionoConsorcio(props.item, $event)"
                      />
                    </td>
                    <td :title="props.item.nombre_consorcio_con_tipo_tooltip_formateado" :class="claseFilaCodigoNombre(props.item)" class="pl-0">
                      <div class="d-flex align-center fila-icono-nombre-consorcio">
                        <div class="material-symbols-outlined icono-tipo-consorcio mr-2">
                          {{ props.item.tipo === TIPO_CONSORCIO_EDIFICIO ? 'domain' : 'nature' }}
                        </div>
                        <span class="texto-mostrado-desbordamiento nombre-consorcio-mayusculas">
                          [{{ props.item.id }}] {{ props.item.nombre }}
                        </span>
                      </div>
                    </td>
                    <td v-if="mostrar_deshabilitadas" :class="'columna-chip ' + estiloFilaDeshabilitada(props.item)">
                      <div v-if="props.item.deshabilitado">
                        <span class="etiqueta-deshabilitado">
                          <chip-estado-acuerdo-comercial :estado="props.item.motivo_deshabilitado"/>
                        </span>
                      </div>
                    </td>
                  </tr>
                </template>
              </ca-tabla>
            </div>

            <template v-if="error_no_seleccion">
              <div class="mt-2">
                <span class="texto-error">Seleccioná al menos un consorcio</span>
              </div>
            </template>
          </div>
        </template>

      </v-form>
    </div>
  </div>
</template>

<script>
import { CACHE_ADMIN_MUTATION_AGREGAR_ADMIN, CACHE_ADMIN_MUTATION_OBTENER_UNA_ADMIN, CACHE_ADMIN_MUTATION_MODIFICAR_CONSORCIOS_ADMIN  } from '@/store/administraciones/administraciones.types';
import { APIGeneralSales } from '../../api/general.api';
import { AcuerdoComercial } from '../../../../models/AcuerdoComercial';
import BusquedaAdministracion from '../BusquedaAdministracion.vue';
import ChipEstadoAcuerdoComercial from '../ChipEstadoAcuerdoComercial.vue';
import { TipoConsorcio } from '../../acuerdo-comercial.consts';

export default {
  name:'VistaSeleccionConsorcios',
  components: {
    BusquedaAdministracion,
    ChipEstadoAcuerdoComercial
  },
  props:{
    acuerdo_comercial: { type: AcuerdoComercial, default: () => new AcuerdoComercial() },
    administraciones: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false }, // flag para activar el loading del padre
  },
  data: () => ({
    acuerdo_comercial_copy: null,

    administracion_seleccionada: null, // Administracion que selecciono el usuario
    consorcios: [],
    consorcios_seleccionados: [],
    consorcios_filtrados_por_ca_filtro: [],

    filtro_ca_tabla: '',

    mostrar_deshabilitadas: false, // flag del switch

    error_no_seleccion: false, // Error en caso de no seleccionar ningun consorcio
    TIPO_CONSORCIO_EDIFICIO: TipoConsorcio.EDIFICIO,
  }),
  computed: {

    /**
     * Computed que calcula la cantidad de consorcios seleccionados (necesario esta computed ya que al momento de montar y desmontar el componente, se pierde el valor de la cantidad de consorcios seleccionados si fuera una variable en data).
     */
    cantidadConsorciosSeleccionados() {
      return this.consorcios_seleccionados.length;
    },

    /**
     * Computed que retorna los consorcios filtrados en base a ca-filtro
     */
    consorciosFiltrados(){
      return this.consorcios_filtrados_por_ca_filtro.filter((consorcio) => {
        if (this.mostrar_deshabilitadas){
          return consorcio;
        }
        else{
          return consorcio.deshabilitado ? false : consorcio;
        }
      });
    },

    /**
     * Computed necesaria para detectar que no hay ningun consorcio seleccionado
     */
    errorNingunaSeleccion(){
      return this.consorciosFiltrados.length > 0 && this.consorcios_seleccionados.length === 0;
    },
  },
  /**
   * Cada vez que se monta el componente, hago la copia del acuerdo comercial y actualizó los valores de la vista con el estado actual del AC
   */
  mounted(){
    this.acuerdo_comercial_copy = _.cloneDeep(this.acuerdo_comercial);

    // Recupero el estado actual, si es que tiene
    this.administracion_seleccionada = this.acuerdo_comercial_copy.administracion_seleccionada ?? null;
    this.consorcios_seleccionados = this.acuerdo_comercial_copy.consorcios_seleccionados ?? [];
    this.consorcios = this.acuerdo_comercial_copy.consorcios ?? [];
    this.mostrar_deshabilitadas = this.acuerdo_comercial_copy.mostrar_deshabilitadas;
    this.filtro_ca_tabla = this.acuerdo_comercial_copy.filtro_ca_tabla ?? '';
    this.consorcios_filtrados_por_ca_filtro = this.acuerdo_comercial_copy.consorcios_filtrados_por_ca_filtro ?? [];
  },
  methods: {

    /**
     * Busco los consorcios, cuando selecciona una administracion y marco deshabilitados los que estan facturando o tienen un AC asociado
     */
    buscarConsorcios(admin){

      this.administracion_seleccionada = admin; // Seteo la administración buscada

      if(admin){
        this.error_no_seleccion = false; // reinicio por si habia error

        // Busco primero en cache, para evitar hacer el request
        let admin_en_cache = this.buscarEnCache(admin);

        if (!admin_en_cache){
          this.$emit('update:loading',true);
          APIGeneralSales.getConsorciosAdministracion(admin.getApiLinkHref('consorcios'))
            .then((resp) => {

              admin.consorcios = resp; // Creo atributo para setearle los consorcios (recuperados) a la administracion

              // Actualizo cache con la nueva busqueda
              this.$store.commit(CACHE_ADMIN_MUTATION_AGREGAR_ADMIN, admin);

              this.prepararConsorcios(admin, resp);
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              this.$emit('update:loading',false);
            });
        }
        else{
          this.prepararConsorcios(admin_en_cache, admin_en_cache.consorcios);
        }
      }
    },

    /**
     * Metodo encargado de buscar la administración en la cache
     */
    buscarEnCache(admin){
      let admin_buscada = this.$store.getters[CACHE_ADMIN_MUTATION_OBTENER_UNA_ADMIN](admin);
      return admin_buscada;
    },

    /**
     * Preparo los consorcios marcadolos como NO seleccionados y deshabilitando en caso que tenga AC o sea legacy y esten facturando
     */
    prepararConsorcios(admin, consorcios){
      // Deshabilito + motivo, para aquellos consorcios que esten facturando (legacy) o tengan un AC asignado
      // Podria ser computed, pero lo hago secuencial ni bien recupero los consorcios
      let consorcios_copy = _.cloneDeep(consorcios);

      consorcios_copy.forEach((consorcio) => {

        // Seteo atributo de seleccionado, en false para que siempre esten deseleccionado
        consorcio.seleccionado = false;

        // Calculo el atributo deshabilitado sea que este facturando (consorcios legacy a SALES) o que tenga AC asociado
        consorcio.deshabilitado = !!(consorcio.facturando || consorcio.propuesta_comercial);

        // Calculo el motivo de porque esta deshabilitado (que será Facturando para consorcios legacy o el estado del AC)
        if(consorcio.deshabilitado){
          consorcio.motivo_deshabilitado = consorcio.propuesta_comercial ? consorcio.propuesta_comercial.estado : null;

          // Caso borde: si no tiene motivo por la linea de arriba significa que no tiene AC, por lo tanto, es un consorcio legacy (pre-sales) y se lo asume que esta "facturando" en caso de tener el flag activo, sino null.
          if (!consorcio.motivo_deshabilitado){
            consorcio.motivo_deshabilitado = consorcio.facturando ? 'Facturando' : null;
          }
        }
      });

      this.$store.commit(CACHE_ADMIN_MUTATION_MODIFICAR_CONSORCIOS_ADMIN, {admin_modificada: admin, consorcios_modificados: consorcios_copy});

      this.consorcios = _.cloneDeep(consorcios_copy);
      this.consorcios_seleccionados = [];
    },

    /**
     * Marco el consorcio como seleccionado/deseleccionado
     */
    seleccionoConsorcio(consorcio, seleccionado){

      // Apago el error al momento que selecciona un consorcio
      if(seleccionado && this.error_no_seleccion){
        this.error_no_seleccion = false;
      }

      consorcio.seleccionado = seleccionado;
      seleccionado ? this.consorcios_seleccionados.push(consorcio) : this.consorcios_seleccionados.splice(consorcio, 1);
    },

    /**
     * Metodo invocado desde el padre, para validar esta vista
     */
    validarFormulario(){
      let valido = false;
      valido = this.$refs.formulario_vista_seleccion_consorcios.validate();

      // Valido que haya seleccionado al menos un consorcio
      this.error_no_seleccion = this.consorcios_seleccionados.length === 0;

      // Validaciones de esta vista: Si busco administración y al menos selecciono un consorcio
      if (valido && !this.error_no_seleccion){

        // Guardo es estado actual de la vista en la copia del AC
        this.acuerdo_comercial_copy.administracion_seleccionada = this.administracion_seleccionada;
        this.acuerdo_comercial_copy.consorcios_seleccionados = this.consorcios_seleccionados;
        this.acuerdo_comercial_copy.consorcios = this.consorcios;
        this.acuerdo_comercial_copy.consorcios_filtrados_por_ca_filtro = this.consorcios_filtrados_por_ca_filtro;
        this.acuerdo_comercial_copy.filtro_ca_tabla = this.filtro_ca_tabla;
        this.acuerdo_comercial_copy.mostrar_deshabilitadas = this.mostrar_deshabilitadas;
        this.acuerdo_comercial_copy.tipo_producto = this.obtenerTipoProducto(); // Calculo el tipo de producto seleccionado en base a los consorcios seleccionados
        this.$emit('update:acuerdo_comercial', this.acuerdo_comercial_copy);
      }
      else{
        valido = false;
      }

      return valido;
    },

    /**
     * Metodo que retorna el tipo de producto seleccionado en base a los consorcios seleccionados (para que en la vista previa se muestre el tipo de producto)
     * 
     * Si hay al menos un consorcio de tipo edificio, entonces el tipo de producto es edificio, sino es barrio
     * (en caso de seleccion de ambos tipos, se filtra en la vista del formulario)
     */
    obtenerTipoProducto() {
      return this.acuerdo_comercial_copy.consorcios_seleccionados.some(consorcio => consorcio.tipo === TipoConsorcio.EDIFICIO) ? TipoConsorcio.EDIFICIO : TipoConsorcio.BARRIO;
    },

    /**
     * Activo o no el estilo de fila deshabilitada, si es que el consorcio esta deshabilitado
     */
    estiloFilaDeshabilitada(consorcio){
      return consorcio.deshabilitado ? 'fila-deshabilitada' :  'fila-activa';
    },

    /**
     * Calculo la clase asignada a la fila de la tabla, dependiendo si se muestran los consorcios desactivados y si esta deshabilitado
     */
    claseFilaCodigoNombre(item){
      let clase = 'columna-codigo-nombre-';
      clase+= this.mostrar_deshabilitadas ? 'corta ' : 'larga ';
      clase+= this.estiloFilaDeshabilitada(item);
      return clase;
    },
  },
};
</script>

<style lang="scss">
#vista-seleccion-consorcios{

  .v-text-field__details {
    display: none;
  }

  .v-input__slot {
    margin-bottom: 0;
  }

  .tabla-container{

    .ca-filtro {
      width: auto;
      .ca-filtro-textfield {
        margin: 0 !important;
      }
    }

    .icono-tipo-consorcio {
      color: color(gris);
      font-variation-settings:
        'FILL' 1,
        'wght' 400,
        'GRAD' 0,
        'opsz' 24
    }

    .contenedor-fila-filtros {
      margin-bottom: 8px;
      padding-top: 6px;
      padding-bottom: 6px;

      .chip-totalizador {
        height: 26px;

        .v-chip__content {
          padding-left: 10px;
          padding-right: 10px;
          font-size: 13px;
          line-height: 25.87px;
          background-color: color(dark);
          color: color(blanco);
        }

        &--texto-oscuro {
          font-weight: 700;
          margin-left: 3px;
        }
      }
    }

    .switch-deshabilitadas{
      label{
        color: color(dark);
        font-size: 15px;
      }
      .v-input__slot {
        margin-bottom: 0;
      }
      .v-input--selection-controls {
        margin-top: 0;
      }
      .v-messages {
        display: none;
      }
    }

    .tabla-consorcios{
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.14), 0 3px 4px 0 rgba(0, 0, 0, 0.12),
        0 1px 5px 0 rgba(0, 0, 0, 0.2);

      .v-input--selection-controls {
        margin-top: 0 !important;
      }

      .ca-tabla {
        max-height: 500px;
        min-height: 300px;
        height: auto;
      }

      .tabla-checkbox {
        height:22px;
      }

      .columna-checkbox {
        width: 18px;
      }

      .columna-codigo-nombre-corta {
        width: 130px;
      }
      .columna-codigo-nombre-larga {
        width: 210px;
      }

      .columna-codigo {
        color: color(gris-deshabilitado);
      }

      .columna-chip {
        width: 80px;
        text-align: right;

        .etiqueta-deshabilitado {
          font-size: 11px;
          font-weight: 700;
          color: color(blanco);
        }
      }

      .fila-activa{
        background-color: inherit;
      }

      .fila-deshabilitada{
        background-color: color(fondo-deshabilitado);
        color: color(gris-deshabilitado);
      }

      .texto-mostrado-desbordamiento {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .nombre-consorcio-mayusculas {
        text-transform: uppercase;
      }

      .fila-icono-nombre-consorcio {
        pointer-events: none;
      }
    }

    .texto-error{
      color: color(rojo-error);
      font-size: 12px;
      line-height: 16px;
    }
  }
}
</style>